<script lang="ts">
    //import {ASSET_URL} from "../config";
    import FileUploadBtn from "./FileUploadBtn.svelte";
    import {myStore, entityStore} from "../../stores.js";
    import {element} from "svelte/internal";
    import SingleSelectDropdown from "./SingleSelectDropdown.svelte";
    import { createEventDispatcher } from 'svelte';
    import {ASSET_URL} from "../../config";
    import UploadInfoBox from "./UploadInfoBox.svelte";
    const dispatch = createEventDispatcher();

    export let title = null;
    export let index = null;


    export let disabled;
    //let availableCommunities = $entityStore.availableCommunities;

    let community_id;

    function remove(){
        dispatch('remove');
    }

    function communitySelected(event){

        console.log("community selected:", event.detail);
        //console.log("selection val = ", community_id);
        console.log("forindex =", index);
        //TODO WRONG $myStore.setFields(`bankAccounts.${index}.community_id`,community_id.value);
        $myStore.setFields(`step5.bankAccounts.${index}.community_id`,community_id.value); //convertion needed before post
    }      //console.log("availableCommunities = ", $entityStore.availableCommunities);


</script>

<div class="community-data-box">

        <div class="box-header">
          <h4>
              {#if title} {title} {/if}
          </h4>
            {#if index !== 0}
                <div class="box-remove-btn" on:click={remove}>
                    <div>    <img src="{ASSET_URL}/assets/img/icons/close-white.svg"/></div>

                </div>
            {/if}
        </div>

    <div class="box-content">

        <div class="custom-row mb-3">
            <div class="custom-col-3">

                {#if $myStore.data.step2.pactIsSignedBySyndicate}
                    <SingleSelectDropdown disabled={true} placeholder={$myStore.data.step2.syndicateName}></SingleSelectDropdown>
                {:else}
                    <SingleSelectDropdown {disabled} error={$myStore.errors.step5?.bankAccounts[index].community_id != null} on:select={communitySelected} placeholder="Commune"  bind:selection={community_id} items={$entityStore.availableCommunities}></SingleSelectDropdown>
                {/if}
            </div>
        </div>

        <div class="custom-row">
            <div class="custom-col-8">
                <input type="text" {disabled} class="w-100" name="step5.bankAccounts.{index}.iban" placeholder="IBAN LUX" class:error={$myStore.errors.step5[index]?.iban}/>
            </div>
            <!--
            <div class="custom-col-4">
                <input type="text" class="w-100" name="step5.bankAccounts.{index}.bic"
                       placeholder="Relevé d'identité bancaire (RIB)" class:error={$myStore.errors.step5[index]?.bic}/>
            </div>
            -->
        </div>
        <div class="box-divider"></div>

        <div class="mt-3">
            <h3 class="title">Annexes à fournir</h3>

            <UploadInfoBox
                    withoutOverlay="true"
                    text="Relevé d'identité bancaire (RIB)"
            >
            </UploadInfoBox>
            <div class="mt-3">
                <FileUploadBtn {disabled} maxFiles={2} fieldName="step5.bankAccounts.{index}.files" errorClass={$myStore.errors.step5[index]?.files}></FileUploadBtn>
            </div>
        </div>
    </div>
</div>


<style lang="scss">

  .box-divider {

    margin-top: 1.5rem;
    border-bottom: 1px solid $form-item-bg;
    margin-bottom: 1.5rem;
  }

  .community-data-box {

    background: $secondary-color;
    padding: 1.5rem;
    border-radius: 9px;
    color: #F8F7F7!important;
    flex: 1;


    .box-header {
    display:flex;
      justify-content: space-between;
      align-items: center;
      h4 {
        margin: 0;
        padding: 0;
      }

      .box-remove-btn{

      }

      margin-bottom: 1rem;

    }
  }


</style>
